module.exports = __webpack_public_path__ + "256a5dbbf4cad681861f8b41fd43ec8e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/wave-left-12.png
// module id = 3088
// module chunks = 0